var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.334H18.3337",
    stroke: "#5C5E64",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4585 18.3324L2.50017 8.30739C2.50017 7.79905 2.74183 7.31577 3.14183 6.9991L8.97516 2.45742C9.57516 1.99076 10.4168 1.99076 11.0252 2.45742L16.8585 6.99076C17.2668 7.30742 17.5002 7.79072 17.5002 8.30739V18.3324",
    stroke: "#5C5E64",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9163 9.16602H7.08301C6.39134 9.16602 5.83301 9.72435 5.83301 10.416V18.3327H14.1663V10.416C14.1663 9.72435 13.608 9.16602 12.9163 9.16602Z",
    stroke: "#5C5E64",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 13.541V14.791",
    stroke: "#5C5E64",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.25H11.25",
    stroke: "#5C5E64",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhIcon);
export default __webpack_public_path__ + "static/media/WhIcon.9f2d3d0372bd713a2cad2938ea80ca93.svg";
export { ForwardRef as ReactComponent };